'use strict'

module.exports = {
  CMEditor: {
    dsn: 'https://ac61aeb1c5844072bca44d6cd869d634@sentry.io/138916'
  },
  CMMyAccount: {
    dsn: 'https://5548b7e92241460abe1e30ce9e191335@sentry.io/139042'
  },
  DBSMEditor: {
    dsn: 'https://fdb26e0196a843c5be6f7514309b21b2@sentry.io/98870'
  },
  DBSMViewer: {
    dsn: 'https://0821d2edbaaf494aa59dc98cacbcb7af@sentry.io/139045'
  },
  WixCodeEP: {
    dsn: 'https://28900364d53347659203155b2969c38e@sentry.io/139044'
  },
  WixCodeViewerApp: {
    dsn: 'https://a6c22916726a4b92ab2fd3505bfdf75e@sentry.io/1420524'
  },
  UserErrors: {
    dsn: 'https://ab287a7d15904db8abf8f43937c14146@sentry.io/240637'
  },
  WixData: {
    dsn: 'https://b58591105c1c42be95f1e7a3d5b3755e@sentry.io/286440'
  }
}
